module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_10-a30add60cd266b1df1fb19e930c4473a.png";